var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCalendar = function SvgCalendar(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 12,
    "data-width-20": 15,
    "data-width-24": 18,
    viewBox: "0 0 12 12.5",
    ref: ref
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 10.429,
    x: 0.5,
    y: 1.571,
    stroke: "currentColor",
    rx: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M1 4.5h10"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    d: "M3 .5v2.286M9 .5v2.286"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCalendar);
export default ForwardRef;